import { useState } from "react";
import { api } from "../api";

export function DiscoverScreen() {
  const [slug, setSlug] = useState("");
  const [institution, setInstitution] = useState("");
  const [baseUrl, setBaseUrl] = useState("");
  const [allowed, setAllowed] = useState("/");
  const [blocked, setBlocked] = useState("");
  const [seeds, setSeeds] = useState("/");
  const [result, setResult] = useState<{ id: string; sourceUrl: string | null }[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run() {
    setError(null);
    setBusy(true);
    try {
      const res = await api.discover(
        {
          slug,
          institution,
          baseUrl,
          allowedPaths: allowed.split(",").map((s) => s.trim()).filter(Boolean),
          blockedPaths: blocked.split(",").map((s) => s.trim()).filter(Boolean),
          rateLimitPerMinute: 30
        },
        seeds.split(",").map((s) => s.trim()).filter(Boolean)
      );
      setResult(res.sourceDocuments);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="panel">
      <h2>Kaynak keşfi (connector)</h2>
      <label>Slug</label>
      <input value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="osym" />
      <label>Kurum</label>
      <input value={institution} onChange={(e) => setInstitution(e.target.value)} placeholder="OSYM" />
      <label>Base URL</label>
      <input value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} placeholder="https://www.osym.gov.tr" />
      <label>İzinli path'ler (virgülle)</label>
      <input value={allowed} onChange={(e) => setAllowed(e.target.value)} placeholder="/arsiv/" />
      <label>Engelli path'ler (virgülle)</label>
      <input value={blocked} onChange={(e) => setBlocked(e.target.value)} placeholder="/arsiv/gizli/" />
      <label>Seed sayfalar (virgülle)</label>
      <input value={seeds} onChange={(e) => setSeeds(e.target.value)} placeholder="/arsiv/2023/" />

      <button className="primary" disabled={busy || !slug || !baseUrl} onClick={run}>
        {busy ? "Taranıyor…" : "Keşfet"}
      </button>

      {error && <p className="error">{error}</p>}
      {result && (
        <>
          <p className="ok">{result.length} doküman bulundu ve kaydedildi.</p>
          <table>
            <thead>
              <tr><th>Kaynak URL</th><th>ID</th></tr>
            </thead>
            <tbody>
              {result.map((d) => (
                <tr key={d.id}>
                  <td className="muted">{d.sourceUrl}</td>
                  <td className="muted">{d.id.slice(0, 8)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
